import React, { useEffect, useState } from "react";
import { Box } from "theme-ui";
import { pdf } from "@react-pdf/renderer";

import { Button, PDFContent } from "components";
import { loadingIndicatorGif } from "./loadingIndicatorGif";
import getAllSvgComponents from "utils/getAllSvgComponents";

export default function DownloadSpecsButton({
  userChoicesForUiV2,
  userChoiceValues,
  headerBackgroundColour,
  appHeaderLogo,
  productLogo,
  recipeID,
  iconBefore,
  reviewProduct,
  productName,
  productImages,
  children,
  publicDirectoryUrl,
  sx: sxProps,
}) {
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);

  const [abortFn, setAbortFn] = useState(null);

  const allImages = productImages.map(({ imageSet, images }) => {
    return {
      imageSet,
      images: images
        .filter((img) => img?.url)
        .map((img) => {
          if (img?.type === "svg") {
            return {
              type: "svg",
              fill: img.css.fill,
              url: img.url,
            };
          }
          return {
            ...img,
            url: img?.url?.replace("fmt=auto", "fmt=png"),
          };
        }),
    };
  });

  function loadPDFData() {
    const controller = new AbortController();
    setAbortFn(() => () => controller.abort());
    setIsLoadingPDF(true);
    getAllSvgComponents({ signal: controller.signal, allImages }).then(
      (imagesSVGsAndPNGs) => {
        return pdf(
          PDFContent({
            userChoicesForUiV2: userChoicesForUiV2,
            userChoiceValues: userChoiceValues,
            appHeaderLogo: appHeaderLogo,
            headerBackgroundColour: headerBackgroundColour,
            productLogo: productLogo,
            recipeID: recipeID,
            imagesSVGsAndPNGs,
            publicDirectoryUrl,
          })
        )
          .toBlob()
          .then((blob) => {
            const a = document.createElement("A");
            a.href = URL.createObjectURL(blob);
            a.download = `${productName} ${reviewProduct} ${recipeID.toUpperCase()}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            setIsLoadingPDF(false);
            setAbortFn(null);
          });
      }
    );
  }

  useEffect(() => {
    return () => {
      if (abortFn) {
        abortFn.call(null);
      }
    };
  }, [abortFn]);

  return (
    <Button
      iconBefore={
        isLoadingPDF ? (
          <Box
            as="img"
            src={loadingIndicatorGif}
            alt="Loading..."
            sx={{ height: "26px", display: "block" }}
          />
        ) : (
          iconBefore
        )
      }
      variant="unstyled"
      disabled={isLoadingPDF || !recipeID}
      sx={sxProps}
      onClick={loadPDFData}
    >
      {children}
    </Button>
  );
}
